export enum ColumnPanelEventType {
    SELECT,
    SORT,
}

export enum ColumnPanelActionType {
    EXPAND,
    RELOAD,
}
